import $ from "jquery";
// import * as utils from "./utils";


export default class SPMenu {
  constructor() {}

  init() {
    const $underline = $("#js-menu-underline");
    const baseX = $("#js-menu-wrapper").offset().left;
    const $menuItems = $("#js-menu").find(".menu__item");

    $menuItems.mouseover((e) => {
      const $el = $(e.target).closest(".menu__item");
      const w = $el.width();
      const x = $el.offset().left - baseX;

      $underline.addClass("show");
      $underline.css({
        "width": `${w}px`,
        "left": `${x}px`
      });
    })
    .mouseout(() => {
      $underline.removeClass("show");
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/PCMenu.js